import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPuestos, postPuesto } from "../../../../redux/actions/resolucion";
import NuevoPuestoForm from "./NuevoPuestoForm";

const initialValues = {
  nombre: "",
  ciuo: null,
}

const NuevoPuestoFormContainer = ({ callback, open, handleClose, idDependenciaEmpleador }) => {

  const dispatch = useDispatch();
  const puestos = useSelector((state) => state.resolucion.puestos.data);
  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    if (puestos.length === 0) {
      dispatch(getPuestos(idDependenciaEmpleador));
    }
  }, [])

  useEffect(() => {
    setFormValues(initialValues);
  }, [open])

  const handleSubmit = (values) => {
    dispatch(postPuesto({ ...values, idDependenciaEmpleador })).then((v) => {
      if (callback) {
        callback(v);
      }
    })
    handleClose();
  }

  return (
    <NuevoPuestoForm
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      initialValues={formValues}
    />
  )

}

export default NuevoPuestoFormContainer;